
<app-common-modal #childModalValidate [name]="'editName'" [title]=" " [twoButtonsDialogs]="true" [withFooter]="false">
  <h4 modal-title class="modal-title" translate>T_NAME</h4>
  <app-spinner *ngIf="isLoading" [sizeClass]="'medium'"></app-spinner>
  <div modal-body *ngIf="!isLoading">
    <div class="row g-0" *ngFor="let kv of translationsByLanguages; trackBy: trackByFn">
      <div class="content-container" >
        <div  class="input-edit-translation  row g-0 align-items-center">
          <span class="col-2 label-text">{{kv.getKey()}}</span>
          <div class="col-10">
          <input id="sld" type="text" [value]="kv.getValue()" (input)="tranlationChange(kv.getKey(), $event)" class="edit-input">
          </div>
        </div>

      </div>
    </div>

    <!-- Buttons -->
    <div class="modal-edit-category-name-footer form-horizontal">
      <button class="btn btn-default-white-background" (click)="hide()" translate>T_BUTTON_CANCEL</button>
      <button *ngIf="!isAddedModal" class="btn btn-default-white-background" [disabled]="!isValidForm()" (click)="sendConfirmation(); hide()" translate>T_BUTTON_EDIT</button>
      <button *ngIf="isAddedModal" class="btn btn-default-white-background" [disabled]="!isValidForm()" (click)="sendConfirmation(); hide()" translate>T_BUTTON_ADD</button>
    </div>
  </div>
</app-common-modal>
